export function initBannerController() {
  const banner: HTMLElement | null = document.querySelector('.js-designawardBanner');

  window.addEventListener('scroll', () => {
    if (banner) {
      banner.style.transition = 'right 1s ease-in-out';
      const distanceFromBottom = document.documentElement.scrollHeight - window.innerHeight - window.scrollY;

      if (distanceFromBottom < 300) {
        banner.style.right = '-100%';
      } else {
        banner.style.right = '0';
      }
    }
  });
}
